import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { CommonService } from "../../_services/common.service";

@Component({
  selector: 'app-store-invoice',
  templateUrl: './store-invoice.component.html',
  styleUrls: ['./store-invoice.component.css']
})
export class StoreInvoiceComponent implements OnInit {
  public loading = false;
  public notFound = true;
  public storeInvoiceData = [];

  constructor(private CommonService: CommonService,
    private activateroute: ActivatedRoute,
    private titleService: Title
  ) { }

  ngOnInit() {
    this.loading = true;
    if (this.activateroute.snapshot.params["token"]) {
      let siteDetail = JSON.parse(localStorage.getItem('siteData'));
      if (siteDetail) {
        this.titleService.setTitle("Store Invoice");
        $("#appPrintLifeFavicon").attr("href", siteDetail.site_favicon);
      }
      this.getstoreInvoiceData();
    }
  }

  getstoreInvoiceData = function () {
    this.loading = true;

    this.CommonService.apiServicePublicOrder(
      "GET",
      "store/invoice/" + this.activateroute.snapshot.params["token"]
    ).subscribe(
      (response: any) => {
        this.loading = false;
        if (response.status === true) {
          if (response.data) {
            this.storeInvoiceData = response.data;
            this.notFound = false;
          }
        }
      },
      err => {
        this.loading = false;
        console.log(err);
      }
    );
  }

  printInvoice() {
    window.print(); 
  }

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-public-order/store-invoice/store-invoice.component.ts